import React from "react";
import { useTheme } from "../context/ThemeContext";
import "../styles/sticky.css";

const StickyCategory = ({ item, filterProducts, id, chooseCategory }) => {
  const theme = useTheme();
  return (
    <div
      className={
        chooseCategory === item?.CATEGORY
          ? "choose_categpry_card"
          : "category_card"
      }
      onClick={() => filterProducts(item?.CATEGORY)}
    >
      <p
        className={
          chooseCategory === item?.CATEGORY
            ? "font-bold text-[12px] m-1 text-center text-white"
            : `font-bold text-[12px] m-1 text-center ${theme.primary.text}`
        }
        onClick={() => filterProducts(item?.CATEGORY)}
      >
        {item?.CATEGORY}
      </p>
    </div>
  );
};

export default StickyCategory;
